import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';
import BuilderCard from './components/builder-card';
import ProductCard from './components/product-card';
import ExtendCard from './components/extend-card';
import { withApollo } from 'react-apollo'; 
import DestinationPanel from './components/destination-panel';
import { connect } from 'react-redux';
import { DeleteCurrentBooking } from '../../../actions/currrentBooking';
import { DeleteSector, UpdateSector, FetchBooking } from '../../../actions/booking';
import { bindActionCreators } from 'redux';
import ReactModal from 'react-modal';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import SavePaxModal from '../views/save-pax-modal';
import GapPanel from './components/gap-panel';
import GapCard from './components/gap-card';
import DaySvg from '../../shared/UI/daySvg';
import BedSvg from '../../shared/UI/bedSvg';
import BusSvg from '../../shared/UI/busSvg';
import BagSvg from '../../shared/UI/bagSvg';
import CalendarEditSvg from '../../shared/UI/calendarEditSvg';
import CalenderAltSvg from '../../shared/UI/calendarAltSvg';
import { itineraryListData } from '../../../helpers/itineraryHelper';
// import PaxButton from './components/pax-button';
import InfoSvg from '../../shared/UI/infoSvg';
import CloseRoundSvg from '../../shared/UI/closeRoundSvg';
import StickyBookingHighlight from '../views/sticky-booking-highlights';
import Sticky from 'react-stickynode';
import { GetNextDestination } from '../../../actions/cities';
import cookie from "js-cookie";
import { get } from '../../../helpers/objectHelper';
import SearchPage from '../search/search-page';
import MapButton from '../../shared/UI/map-button';
import Loadable from 'react-loadable';
import Spinner from '../../shared/UI/spinner';
import { store } from '../../../index';
import { SET_BOOKING_DETAILS } from '../../../actions/types';
import { getCyoaName } from '../../../helpers/cyoaHelper';
import { history } from '../../App';
import { authToken } from '../../../actions/utils';

ReactModal.setAppElement('#root');
dayjs.extend(AdvancedFormat);

const MapBoxWithNoSSR = Loadable({ loader: () => import('../../shared/mapbox/index'), loading() { return <Spinner loadClass="loading-spinner" />  }});
const queryString = require('query-string');
const builderMapDataSet = (document.getElementById("root").dataset.buildermap !== undefined) ? JSON.parse(document.getElementById("root").dataset.buildermap) : false;


class AdventureBuilderPage extends PureComponent {

    constructor(props){
        super(props);
        
        this.state = {
            showAddPaxModal:false,
            showChangeModal:false,
            isUpdating:false,
            showAddGapPanel:false,
            stickyBHEnabled:false,
            view:"builder",
            mapActive:builderMapDataSet,
            mapStickyEnabled:builderMapDataSet,
        }

        this.onContinue = this.onContinue.bind(this);
        this.onChangeView = this.onChangeView.bind(this);
        this.onRemoveDestination = this.onRemoveDestination.bind(this);
        this.onExtend = this.onExtend.bind(this);
        this.onAddGap = this.onAddGap.bind(this);
        this.onBack = this.onBack.bind(this);

        this.openAddPaxModal = this.openAddPaxModal.bind(this);
        this.closeAddPaxModal = this.closeAddPaxModal.bind(this);
        this.openChangeModal = this.openChangeModal.bind(this);
        this.closeChangeModal = this.closeChangeModal.bind(this);
        this.mapHandler = this.mapHandler.bind(this);
    }

    openAddPaxModal(){ this.setState({showAddPaxModal:true}); }
    closeAddPaxModal(){ this.setState({showAddPaxModal:false}); }
    openChangeModal(){ this.setState({showChangeModal:true}); }
    closeChangeModal(){ this.setState({showChangeModal:false}); }

    onBack(){
        window.location.href = `${process.env.REACT_APP_PLANNER_URL}`;
    }

    onContinue(){

        //show pax modal or itinerary page
        const { currentBooking:{uuid, passengers} } = this.props;
        const token = cookie.get("ap.token");
        const hasPaxDetails = get([0, 'first_name'], passengers, null);

        if(hasPaxDetails !== "Adult 1"){
            window.location.href = `${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ITINERARY_PAGE}?id=${uuid}&t=${token}`;
        }else{
            this.openAddPaxModal();
        }

    }

    async componentDidMount(){

        const { client } = this.props;
        const bookingId = queryString.parse(window.location.search).id;

        if(bookingId !== undefined){
            this.onChangeView('builder');
            await authToken();
            const response = await FetchBooking(client, bookingId);
            if(response) this.setState({isReady:true});
            await GetNextDestination(client, response.data.getBooking.uuid, 7);
        }else{
            this.onChangeView('search-widget');
        }

        this.setState({
            stickyBHEnabled:window.matchMedia("(min-width: 979px)").matches ? true : false,
            mapActive:(window.matchMedia("(min-width: 40em)").matches && builderMapDataSet) ? true : false, 
            mapStickyEnabled:(window.matchMedia("(min-width: 64em)").matches && builderMapDataSet) ? true : false
        });
    }

    componentWillUnmount(){
        this.setState({
            showAddPaxModal:false,
            isUpdating:false,
            showAddGapPanel:false,
            mapActive:false
        });
    }

    onChangeView(view){  
        if(view === "search-widget"){
            this.setState({view:"search-widget", showChangeModal:false})
            history.push('/builder');
            store.dispatch({type:SET_BOOKING_DETAILS, payload:{}});
        }

        if(view === "builder"){
            this.setState({view:"builder"})
        }
    }

    onRemoveDestination(sectorId){

        const { currentBooking:{uuid}, client, isLoading } = this.props;

        this.setState({isUpdating:true});

        if(!isLoading){
            DeleteSector(client, uuid, sectorId).then(()=>{
                this.setState({isUpdating:false});
                
                //toggle 'add gap' panel if active
                if(this.state.showAddGapPanel) this.onAddGap();
            });
        }

        //Scroll into view
        ReactDOM.findDOMNode(this).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

    onExtend(sectorId, date, nights){

        const {currentBooking:{uuid}, client, isLoading } = this.props;

        this.setState({isUpdating:true});

        if(!isLoading){
            UpdateSector(client, uuid, parseInt(sectorId, 10), nights, date).then(()=>{
                this.setState({isUpdating:false});

                //toggle 'add gap' panel if active
                if(this.state.showAddGapPanel) this.onAddGap();
            });
        }
    }

    renderBuilderCards(data, index){
        switch(data.type){
            case "city":
            case "start":
            case "overnight":
                return (
                    <BuilderCard 
                        id={'builder-view'}
                        showClose={true}
                        showPlus={false}
                        index={index}
                        builderData={data}
                        onCloseClicked={() => this.onRemoveDestination(data.id)}
                    />
                )
            case "product": 
                return (
                    <ProductCard 
                        id={'builder-view'}
                        showClose={true}
                        showPlus={false}
                        index={index}
                        builderData={data}
                        onCloseClicked={() => this.onRemoveDestination(data.id)}
                    />
                )

            case "extend":
                return (
                    <ExtendCard 
                        index={index}
                        builderData={data}
                        onExtendClicked={() => this.onExtend(data.id, data.date, data.nights)}
                        />  
                )

            case "gap":
                if(data.message === "ACCOMMODATION_GAP"){
                    return (
                        <ExtendCard 
                            index={index}
                            builderData={data}
                            onExtendClicked={() => this.onExtend(data.id, data.date, data.nights)}
                            />  
                    )
                } 
               return (
                   <GapCard 
                        index={index}
                    />
               )

            default:
                return (
                    <BuilderCard 
                        id={'builder-view'}
                        showClose={true}
                        showPlus={false}
                        index={index}
                        builderData={data}
                        onCloseClicked={() => this.onRemoveDestination(data.id)}
                    />
                )
               
        }
    }

    onAddGap(){
        this.setState({showAddGapPanel: !this.state.showAddGapPanel});
    }

    mapHandler(){
        this.setState({mapActive: !this.state.mapActive}, () => {
            if(window.innerWidth < 640) document.querySelector('body').classList.toggle('overflow-hidden');
        });
    }

    render(){

        const { showAddPaxModal, isUpdating, showAddGapPanel, showChangeModal, stickyBHEnabled, view, mapActive, mapStickyEnabled } = this.state;

        const { itinerary, meta } = this.props;
        const _itineraryList = (itinerary === undefined) ? [] : itinerary;     
        const _stops = meta !== undefined ? meta.stops : 0;
        const _trips = meta !== undefined ? meta.trips : 0;
        const _days = meta !== undefined ? meta.days : 0;    
        const { startCity, lastCity, date, accommodationNight } = itineraryListData(0, _itineraryList);
        const _mapBoxSequence = (itinerary !== undefined && itinerary.length > 0) ? itinerary : [];        
        const parsed = (typeof window !== 'undefined') ? queryString.parse(window.location.search) : {};

        return (
            <Fragment>
                <div className="max-width-5 mx-auto">
                { 
                    (view === "search-widget") && 
                    (   
                    <div className="clearfix margin-t-100">
                        <div className="col col-12 px">
                            <SearchPage isBAB={true} onChangeView={this.onChangeView} />
                        </div>
                    </div>
                    )
                }
            
                { 
                    (view === "builder") &&
                    (
                        <Fragment>

                            <Sticky enabled={stickyBHEnabled} activeClass={"sticky-bh-active"}>{ status => { if (status.status === Sticky.STATUS_FIXED) return <StickyBookingHighlight view={"builder"} showAddGapPanel={showAddGapPanel} clickHandler={this.onContinue} /> }}</Sticky>
                            <MapButton mapHandler={this.mapHandler} active={mapActive} />

                            <div className={`${mapActive ? "col col-12 lg-col-6 px2" : ""}`}>

                            <div className={`booking-highlight margin-t-100 clearfix`}>
                                <div className={`${mapActive ? "col-12 mx-auto" : "col-12 sm-col-9 md-col-7 mx-auto" }`}>
                                    <div className="clearfix margin-t-20">
                                        <div className="col col-12 px2">
                                            <h4 className="left inline busabout-h4 mr2">{startCity} to {lastCity}</h4>
                                            <button type="button" className={`rounded-svg-btn isChange isBuilder`} onClick={this.openChangeModal}><CalendarEditSvg clazz="mr1" />Change</button>
                                        </div>
                                </div>

                                <div className="lg-flex clearfix icon-container margin-t-10 margin-b-20">    
                                        <div className="lg-flex col col-12 sm-col-8 px2 items-center">
                                            <DaySvg clazz={"mr1"} /> <span className="bold mr2">{_days} days</span>
                                            <BedSvg clazz={"mr1"} /> <span className="bold mr2">{accommodationNight} nights</span>
                                            <BusSvg clazz={"mr1"} /> <span className="bold mr2">{_stops} stops</span>
                                            { _trips > 0 && <><BagSvg clazz={"mr1"} /> <span className="bold mr2">{_trips} trips</span></> }
                                        </div>

                                        {/* <div className="lg-flex col col-12 sm-col-4 justify-end px2">
                                            <PaxButton />
                                        </div> */}
                                    </div>   

                                <div className="clearfix">   
                                        <div className="col col-12 px2">
                                            <p className="description-text margin-b-20">
                                            <span className="orange-text bold">Trip starts on {dayjs(date).format("Do MMMM YYYY")} from {startCity}</span>.  
                                            Add more destinations, the length of stay and link-up with sailing, festivals and small group adventure trips for the ultimate itinerary. 
                                            </p>
                                        </div>    
                                    </div>

                                </div>
                            </div>

                            <div className="clearfix">
                                <div className={`${mapActive ? "col-12 mx-auto" : "mx-auto col-12 sm-col-10 md-col-8 px2"}`}>
                
                                    <ul className="builder-list">
                                    { 
                                        _itineraryList.map((data, index) => {

                                            //Cache-bust newly added/removed images
                                            const renderKey = !isUpdating ? index : Math.random();

                                            //conditional class value for product/city and extends
                                            const itineraryDataType = (index !== 0 && data.type === "start") ? 'gap-start' : data.type;
                                            const preGapType = ((data.type === "city" || data.type === "start") && _itineraryList[ index < _itineraryList.length -1  ? index + 1 : 0].type === "gap") ? 'pre-gap' : '';
                                            const doubleGapType = (itineraryDataType === "gap-start" && _itineraryList[ index < _itineraryList.length -1  ? index + 1 : 0].type === "gap") ? 'pre-gap' : '';
                                            const productCityOrExtends = (data.type !== "extend") ? `builder-list-item builder-list-item-card ${itineraryDataType} ${preGapType} ${doubleGapType} ${(_itineraryList.length === index + 1 )? 'last': ''} ` : `extend-list-item`;
                                            return <li key={renderKey} className={productCityOrExtends}> { this.renderBuilderCards(data, index) }</li>
                            
                                        })
                                    }

                                    {
                                        !showAddGapPanel ? 
                                        <li className="builder-list-item"><DestinationPanel /></li> : 
                                        <li className="builder-list-item"><GapPanel onCloseClicked={this.onAddGap} /></li>
                                    }
                                    </ul>

                                </div>
                            </div> 

                            <div className="clearfix">
                                <div className="mx-auto col-12 px2 margin-t-40 margin-b-40 center">

                                {
                                    ( (_itineraryList.length > 1 && !showAddGapPanel)) && <button className="agent-portal-grey busabout--cta--link margin-b-40 block col-12" onClick={this.onAddGap}>
                                    <CalenderAltSvg clazz={"mr2"} />
                                    Add <span className="bold">new destinatons</span> and <span className="bold">start date to create</span> gaps in itinerary 
                                    </button>
                                }

                                { (_itineraryList.length > 1 && !showAddGapPanel) && <button className="busabout--cta orange rounded-corner" onClick={this.onContinue} disabled={_stops >= 1 ? false : true}>Get Price Quote</button> }
                                    
                                </div>
                            </div>

                            </div>


                            <div className={`${mapActive ? "col col-12 lg-col-6 px2" : ""}`}>
                                { 
                                    mapActive && (
                                        <Sticky enabled={mapStickyEnabled} top={90} innerZ={999998}>
                                            <MapBoxWithNoSSR destination={getCyoaName(parsed)} countriesShow={_mapBoxSequence} clickable={true} id={"mapContainer"} />
                                        </Sticky>
                                    )  
                                } 
                            </div> 


                            { 
                                showAddPaxModal && (
                                    <ReactModal
                                        className="youtube-modal"
                                        overlayClassName="modal-overlay white"
                                        isOpen={showAddPaxModal}
                                        contentLabel="Youtube modal">
                                        <div className="max-width-5 mx-auto clearfix">

                                            <div className="col col-12 px2">
                                                <div className="youtube-content pax-modal">
                                                    <SavePaxModal />
                                                </div>
                                            </div>

                                        </div>
                                        <button className="close-button left" type="button" onClick={this.closeAddPaxModal}></button>
                                    </ReactModal>
                                )
                            }

                            {
                                showChangeModal && (
                                    <ReactModal
                                        className="include-modal basket"
                                        overlayClassName="modal-overlay semi-white"
                                        isOpen={showChangeModal}
                                        onRequestClose={this.closeChangeModal}
                                        contentLabel="Include modal">
                                
                                        <div className="max-width-5 mx-auto clearfix">
                                            <div className="col col-12 center">

                                                <InfoSvg />

                                                <h4 className="mb1 mt2">Hey Wait!</h4>
                                                <p className="medium margin-b-30">Are you sure you want to change start destination?</p>
                                                <button type="button" className="busabout--cta orange rounded-corner inline" onClick={() => this.onChangeView('search-widget')}>
                                                    Confirm
                                                </button>
                                            </div>
                                    
                                            <div className="col col-12 px2">
                                                <button className="modal-close" onClick={this.closeChangeModal}><CloseRoundSvg /></button>
                                            </div>
                                        </div>
                                
                                    </ReactModal>                        
                                )
                            }
                      
                        </Fragment>
                    )
                }

                <button className="close-button left" type="button" onClick={this.onBack}></button>   
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = state => {
    return{
        currentBooking:state.currentBooking,
        itinerary:state.currentBooking.itinerary,
        nextDestinations:state.nextDestinations,
        isLoading:state.cart.update_sector_loading,
        meta:state.currentBooking.meta
    }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    DeleteCurrentBooking
  }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(AdventureBuilderPage));